<template>
  <div>
    <div class="air__utils__heading">
      <h5>{{ $route.params.organization_id }}</h5>
    </div>
    <div class="row">
      <div class="col-xl-12 col-lg-6">
        <div class="card">
          <div class="card-body">
            <single-organization :organizationId="$route.params.organization_id" />
          </div>
        </div>

      </div>
      <div class="col-xl-4 col-lg-6">

      </div>
    </div>
  </div>
</template>
<script>
import SingleOrganization from '../../components/widgets/Organizations/SingleOrganization.vue'
// import moment from 'moment'
export default {
  components: {
    SingleOrganization,
  },
}
</script>
